import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import type { AlertSettingParam } from "types/alerts.types"

import { formatSelectTelemetries, getEntityTelemetries } from "helpers/utils/telemetries"
import useTower from "helpers/hooks/towers/useTower"
import TelemetryInput from "../TelemetryInput"

interface TowerTelemetryInputProps {
  param: AlertSettingParam
  towerId: number
}

const TowerTelemetryInput = ({ param, towerId }: TowerTelemetryInputProps) => {
  const { t } = useTranslation()
  const { tower } = useTower({ id: towerId })

  const towerSettings = useMemo(() => tower?.settings, [tower?.settings])

  const telemetries = useMemo(
    () => getEntityTelemetries("tower", { towerSettings }),
    [towerSettings],
  )
  const selectTelemetries = useMemo(
    () => formatSelectTelemetries(telemetries, t) || [],
    [telemetries, t],
  )

  return <TelemetryInput param={param} telemetries={selectTelemetries} />
}

export default TowerTelemetryInput
